import { HbsModal } from '../components/hbs/Modal';
import { HbsButton } from '../components/hbs/Button';

interface Props {
  open: boolean;
  /** "Get started" — closes the modal and reveals the checklist. */
  onGetStarted: () => void;
  /** "Skip for now" — dismisses onboarding entirely. */
  onSkip: () => void;
}

/**
 * One-time welcome shown right after registration. Sets expectations and hands
 * off to the getting-started checklist. Both buttons close the modal; "Skip"
 * also dismisses the checklist so power users aren't nagged.
 */
export function WelcomeModal({ open, onGetStarted, onSkip }: Props): JSX.Element | null {
  return (
    <HbsModal
      open={open}
      onClose={onGetStarted}
      title="Welcome to Hey Be Safe"
      size="md"
      dismissOnBackdrop={false}
    >
      <p>
        Your safe is ready. A few quick steps will get you to the good part —
        passwords that fill themselves in as you browse.
      </p>
      <ul className="list-disc pl-5 space-y-1 text-hbs-text-mute">
        <li>Install the browser extension and try autofill</li>
        <li>Import your existing passwords</li>
        <li>Set up family sharing and account recovery</li>
      </ul>
      <p className="text-hbs-text-mute">
        We've put these in a checklist on your safe — do them whenever you like.
      </p>
      <div className="mt-6 flex justify-end gap-2">
        <HbsButton variant="ghost" id="welcome-skip-button" onClick={onSkip}>
          Skip for now
        </HbsButton>
        <HbsButton id="welcome-get-started-button" onClick={onGetStarted}>Get started</HbsButton>
      </div>
    </HbsModal>
  );
}
